import { connect } from "react-redux"
import React, { Component } from 'react';
import './Common.css';
import './Overlay.css';
import { changePageContext, requestNewArbiter, acceptNewArbiter, rejectNewArbiter, changeTextInput, showOverlay } from "../actions/betActions"
import UsernameInput from './UsernameInput';

const stateMap = (store) => {
    return {
        selectedPage: store.bet.selectedPage,
        textInputData: store.bet.textInputData,
        pageContext: store.bet.pageContext,
        authentication: store.bet.authentication,
        ethPrice: store.bet.ethPrice
    };
};
class Overlay extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.closeOverlay = this.closeOverlay.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.getInput = this.getInput.bind(this);
        this.getContext = this.getContext.bind(this);
        this.changeTextInput = this.changeTextInput.bind(this);
        this.requestNewArbiter = this.requestNewArbiter.bind(this);
        this.rejectNewArbiter = this.rejectNewArbiter.bind(this);
        this.acceptNewArbiter = this.acceptNewArbiter.bind(this);
        this.node = null;
    }
  
    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }

    getContext() {
        let { VIEW_PROPOSAL_CONTEXT={} } = this.props.pageContext;
        let { keyProposal="", keyUsername="", pendingRequestNewArbiter=false } = VIEW_PROPOSAL_CONTEXT;
        return { keyProposal, keyUsername, pendingRequestNewArbiter };
    }

    getInput() {
        let { VIEW_PROPOSAL={} } = this.props.textInputData;
        let { proposedArbiter="" } = VIEW_PROPOSAL;
        return { proposedArbiter };
    }

    changeTextInput(event) {
        let name = event.target.name;
        let value = event.target.value;
        let page = event.target.getAttribute("page");

        this.props.dispatch(changeTextInput(name, value, page));
    }

    handleOutsideClick(event) {
        console.log("handleOutsideClick");
        console.log(this.node);

        if(this.node.contains(event.target)) {
            return;
        }

        this.closeOverlay(event);
    }

    closeOverlay(event) {
        this.props.dispatch(showOverlay(false));
        this.props.dispatch(changePageContext({changeArbiterOverlay: false, reviewArbiterOverlay: false}, "VIEW_PROPOSAL"));
    }

    requestNewArbiter(event) {
        console.log("requestNewArbiter");

        let input = this.getInput();
        let context = this.getContext();
        this.props.dispatch(requestNewArbiter(this.props.authentication.uuid, context.keyUsername, context.keyProposal, input.proposedArbiter));
    }

    rejectNewArbiter(event) {
        console.log("rejectNewArbiter");

        let context = this.getContext();
        this.props.dispatch(rejectNewArbiter(this.props.authentication.uuid, context.keyUsername, context.keyProposal, event.target.getAttribute("arbiter")));
    }

    acceptNewArbiter(event) {
        console.log("acceptNewArbiter");

        let context = this.getContext();
        this.props.dispatch(acceptNewArbiter(this.props.authentication.uuid, context.keyUsername, context.keyProposal, event.target.getAttribute("arbiter")));
    }

    render() {  

        let showOverlay = false;
        let overlayType = "AUTH";
        let opponentRequestedArbiter = "";
        let opponent = "";

        let { VIEW_PROPOSAL_CONTEXT={} } = this.props.pageContext;
        let { changeArbiterOverlay=false, reviewArbiterOverlay=false, participant1="", participant2="", arbiter="", requestedArbiter={} } = VIEW_PROPOSAL_CONTEXT;
        if(this.props.selectedPage === "VIEW_PROPOSAL") {

            let username = this.props.authentication.username;
            opponent = (participant1 !== username ? participant1 : participant2);
    
            opponentRequestedArbiter = (requestedArbiter.hasOwnProperty(opponent) && requestedArbiter[opponent]) || "";
            
            if(reviewArbiterOverlay) {
                if(arbiter !== "" && opponent !== "" && opponentRequestedArbiter !== "") {
                    showOverlay = true;
                    overlayType = "REVIEW_ARBITER";
                }
            }
            else if(changeArbiterOverlay) {
                showOverlay = true;
                overlayType = "CHANGE_ARBITER";
            }
        }
        
        let input = this.getInput();
        let context = this.getContext();
        let disabled = context.pendingRequestNewArbiter;

        return (
            <div>
                <div className={"fadeOverlay" + (showOverlay ? "" : " hide")}></div>
                <div className={"contentOverlay" + (showOverlay ? "" : " hide")}>
                    <div className="menuPlaceholder"></div>
                    <div ref={node => this.node = node} className="dialog moveTop40">
                        {overlayType === "AUTH" && (
                        <div>
                            <button className="btn posTopRight">Close</button>
                            <div className="">
                                <div className="padBottom"></div>
                                <div className="labelInputGroup moveTop40">We don't recognize this computer</div>
                                <div className="moveTop20"><button className="btn" onClick={this.signMessage}>Sign message to verify identity</button></div>
                                <div className="labelInput moveTop20">Make sure you're logged in to your Ethereum account (such as Metamask), and click the above button.</div>
                            </div>
                        </div>
                        )}
                        {overlayType === "CHANGE_ARBITER" && (
                        <div>
                            <button className="btn posTopRight" onClick={this.closeOverlay}>Close</button>
                            <div className="">
                                <div className="padBottom"></div>
                                <div className="labelInputGroup moveTop40">Propose new arbiter</div>
                                <UsernameInput disabled={disabled} className="moveTop20" name="proposedArbiter" value={input.proposedArbiter} onChange={this.changeTextInput} page="VIEW_PROPOSAL" />
                                <div><button  disabled={disabled} onClick={this.requestNewArbiter} className={"btn moveTop20 " + (disabled ? " disabled" : "")} >Submit</button></div>
                            </div>
                        </div>
                        )}
                        {overlayType === "REVIEW_ARBITER" && (
                        <div>
                            <button className="btn posTopRight" onClick={this.closeOverlay}>Close</button>
                            <div className="">
                                <div className="padBottom"></div>
                                <div className="labelInputGroup moveTop40">Request to change arbiter</div>
                                <div className="normalText moveTop20">@{opponent} proposed changing the arbiter from @{arbiter} to @{opponentRequestedArbiter}</div>
                                <div><button arbiter={opponentRequestedArbiter} disabled={disabled} className={"btn btnReject moveTop20" + (disabled ? " disabled" : "")} onClick={this.rejectNewArbiter}>Reject @{opponentRequestedArbiter} as arbiter</button></div>
                                <div><button arbiter={opponentRequestedArbiter} disabled={disabled} className={"btn btnAccept moveTop20" + (disabled ? " disabled" : "")} onClick={this.acceptNewArbiter}>Accept @{opponentRequestedArbiter} as arbiter</button></div>
                            </div>
                        </div>
                        )}
                    </div>

                </div>
            </div>
      );
    }
  }

  export default connect(stateMap)(Overlay);







// WEBPACK FOOTER //
// ./src/components/Overlay.js